import {brandConfigObjectMap} from "@/brand/brandConfig";
export const brandConfigMap = new Map();

brandConfigMap.set('http://localhost:8080', getBrandConfig('vc-za-en'));
brandConfigMap.set('http://192.168.88.174:8080', getBrandConfig('vc-za-en'));
brandConfigMap.set('https://goalrush.goalgambit.co.za', getBrandConfig('vc-za-en'));
brandConfigMap.set('default', getBrandConfig('vc-za-en'));

export function getBrandConfig(brand) {
    const brandConfigObject = brandConfigObjectMap.get(brand);
    if (!brandConfigObject) {
        // Return a default config if the brand is not found
        return {
            brand,
            productId: null,
            productTitle: '',
            categoryId: null,
            showTermsConditions: false,
            showDataWon: false,
            serviceId: '',
            quizIncAllAccessServiceId: '',
            newIntegration: false,
            baseRoute: '/'
        };
    }
    return {
        brand,
        productId: brandConfigObject.productId,
        productTitle: brandConfigObject.productTitle,
        categoryId: brandConfigObject.categoryId,
        showTermsConditions: brandConfigObject.showTermsConditions,
        showDataWon: brandConfigObject.showDataWon,
        serviceId: brandConfigObject.serviceId,
        quizIncAllAccessServiceId: brandConfigObject.quizIncAllAccessServiceId,
        newIntegration: brandConfigObject.newIntegration,
        baseRoute: brandConfigObject.baseRoute,
    }
}
